import { atom } from "recoil";

export const emailSentState = atom({
    key: 'emailSent',
    default: true
});

export const activeStepResetPasswordState = atom({
    key: 'activeStepResetPassword',
    default: 0
});

export const completedStepResetPasswordState = atom({
    key: 'completedStepResetPassword',
    default: {}
})